export default __webpack_public_path__ + "static/media/bootTtsIt_It60.ffba35d2.mp3";